import {h, Fragment} from "preact"
import { useAppStateSelector } from "@nosto/preact"
import Sidebar from "./Sidebar"
import { useEffect, useState } from "preact/hooks";

/**
 * ContentWrapper takes a function to render non-empty results in the content area.
 * On loading the Loader is used and for empty results the NoResults component is used.
 */
function ContentWrapper({ type, children }) {
    const {
        foundProducts,
        loading
    } = useAppStateSelector(state => ({ 
        foundProducts: state.response.products?.total > 0, 
        loading: state.loading }))

    const [isChecked, setIsChecked] = useState(false);
    
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        const handleScroll = () => {
            const serpElement = document.querySelector(".ns-serp");
            if (!serpElement) return;

            const serpTop = serpElement.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;

            // Check if the top of .ns-serp is not in the viewport
            const isNotVisible = serpTop > windowHeight || serpTop < 0;

            setIsVisible(!isNotVisible);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    return (
        <div class="ns-serp ns-d-flex ns-flex-column ns-flex-md-row ns-font-inherit ns-my-0 ns-mx-auto"
            data-nosto-element={type}>
            {/* {foundProducts && <Sidebar />} */}
            <div
                class="ns-d-block ns-d-md-inline ns-w-100 ns-border-box"
                style={{ position: loading ? "relative" : "initial" }}
            >
                { children({ loading, foundProducts, isChecked, setIsChecked, isVisible }) }
            </div>
        </div>
    )
}

export function wrapContent(type, Component) {
    return () => (<ContentWrapper type={type}>{Component}</ContentWrapper>)
}

